import { Org } from "./site";

export const isAllowedInOrg = (
  org: (string | null)[] | null | undefined,
  currentOrg: Org
) => {
  return org === null || (Array.isArray(org) && org.includes(currentOrg));
};

export const contentfulLocale = (locale: string) => {
  if (!locale) {
    return "";
  }
  if (locale === "en") {
    return "en-GB";
  }
  return locale.replace("_", "-");
};
